module.exports = __webpack_public_path__ + "img/attraction2.ae995f3d.jpg";